import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {ProfileRoutingModule} from './profile-routing.module';
import {ProfileComponent} from './profile/profile.component';
import {ProfileAddressComponent} from './profile-address/profile-address.component';
import {ProfileAccountComponent} from './profile-account/profile-account.component';
import {ProfileDashboardComponent} from './profile-dashboard/profile-dashboard.component';
import {ProfileSidebarComponent} from './profile-sidebar/profile-sidebar.component';
import {ProfileOrderComponent} from './profile-order/profile-order.component';
import {AddressModule} from '../address/address.module';
import {ProfileOrderListingComponent} from './profile-order-listing/profile-order-listing.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PipeModule} from "../pipe/pipe.module";
import {PreOrderedItemComponent} from './pre-ordered-item/pre-ordered-item.component';
import {MadeToOrderedItemComponent} from './made-to-ordered-item/made-to-ordered-item.component';
import {InstockOrderedItemComponent} from './instock-ordered-item/instock-ordered-item.component';
import {OrderFeedbackToastComponent} from './order-feedback-toast/order-feedback-toast.component';
import {ReviewModule} from "../review/review.module";
import { OrderThankYouComponent } from './order-thank-you/order-thank-you.component';
import { OrderCancellationDialogComponent } from './order-cancellation-dialog/order-cancellation-dialog.component';
import { OrderItemProcessStatusComponent } from './order-item-process-status/order-item-process-status.component';
import { OrderItemProcessOverviewComponent } from './order-item-process-overview/order-item-process-overview.component';
import { OrderListCardComponent } from './order-list-card/order-list-card.component';
import {LoaderModule} from "../loader/loader.module";
import { ProfileCustomOrderComponent } from './profile-custom-order/profile-custom-order.component';
import { CustomOrderItemComponent } from './custom-order-item/custom-order-item.component';
import { CustomOrderItemProcessOverviewComponent } from './custom-order-item-process-overview/custom-order-item-process-overview.component';
import { CustomOrderItemProcessStatusComponent } from './custom-order-item-process-status/custom-order-item-process-status.component';


@NgModule({
	declarations: [
		ProfileComponent,
		ProfileAddressComponent,
		ProfileAccountComponent,
		ProfileDashboardComponent,
		ProfileSidebarComponent,
		ProfileOrderComponent,
		ProfileOrderListingComponent,
		PreOrderedItemComponent,
		MadeToOrderedItemComponent,
		// OrderedItemComponent,
		InstockOrderedItemComponent,
		OrderFeedbackToastComponent,
  OrderThankYouComponent,
  OrderCancellationDialogComponent,
  OrderItemProcessStatusComponent,
  OrderItemProcessOverviewComponent,
  OrderListCardComponent,
  ProfileCustomOrderComponent,
  CustomOrderItemComponent,
  CustomOrderItemProcessOverviewComponent,
  CustomOrderItemProcessStatusComponent
	],
    imports: [
        CommonModule,
        ProfileRoutingModule,
        AddressModule,
        FormsModule,
        ReactiveFormsModule,
        PipeModule,
        ReviewModule,
        LoaderModule
    ]
})
export class ProfileModule {
}
